import { createGetFullKeyEndpointFromExisting } from '@lib';
import { getDataSecurityApplications } from './getDataSecurityApplications';

export const getDataSecurityApplicationsAll = createGetFullKeyEndpointFromExisting(
	({ ...rest }) => getDataSecurityApplications({
		...rest,
		ordering: 'LastUsedDate~d'
	})
);
